<H1> Digital In<app-loader [status]="loaderStatus"></app-loader></H1>

<mat-tab-group>
  <div *ngFor="let y of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">{{y}}
    <mat-tab label="DI {{ 1 + (y * 64)}}- {{ (y+1) * 64}}" >

      <kendo-card  class="digitalin-card" *ngFor="let tile of tiles; let i = index" >
        <kendo-card-header class="k-hstack">
          <h1 kendoCardTitle>
            <kendo-icon name="clip"></kendo-icon>
            DI {{  (y * 64) +(i * 16) + 1 }} - {{  (y * 64) +((i+1) * 16)  }}
          </h1>
        </kendo-card-header>

        <hr kendoCardSeparator/>

        <kendo-card-body>
          <div *ngFor="let x of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
            <app-digitalindetails [refNumber] = "(y*64)+ (i*16) + x" ></app-digitalindetails>
          </div>
        </kendo-card-body>
        <kendo-card-footer>
        </kendo-card-footer>
      </kendo-card>

    </mat-tab>
  </div>
</mat-tab-group>

<!--<kendo-tabstrip [scrollable]="true">-->
<!--  <kendo-tabstrip-tab *ngFor="let y of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]" >-->

<!--    <ng-template kendoTabTitle>-->
<!--      <span>               DO {{  (y * 16) +(1 * 16) + 1 }} - {{  (y * 16) +((1+1) * 16)  }}</span>-->
<!--    </ng-template>-->

<!--    <ng-template kendoTabContent >-->


<!--      <kendo-card  class="digitalin-card" *ngFor="let tile of tiles; let i = index" >-->
<!--        <kendo-card-header class="k-hstack">-->
<!--          <h1 kendoCardTitle>-->
<!--            <kendo-icon name="clip"></kendo-icon>-->
<!--            DO {{  (y * 16) +(i * 16) + 1 }} - {{  (y * 16) +((i+1) * 16)  }}-->
<!--          </h1>-->
<!--        </kendo-card-header>-->

<!--        <hr kendoCardSeparator/>-->

<!--        <kendo-card-body>-->
<!--          <div *ngFor="let x of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">-->
<!--            <app-digitalindetails [refNumber] = "(y*64)+ (i*16) + x" ></app-digitalindetails>-->
<!--          </div>-->
<!--        </kendo-card-body>-->
<!--        <kendo-card-footer>-->
<!--        </kendo-card-footer>-->
<!--      </kendo-card>-->

<!--    </ng-template>-->
<!--  </kendo-tabstrip-tab>-->
<!--</kendo-tabstrip>-->


